<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form
          :inline="true"
          size="mini"
          label-width="100px"
          :model="searchForm"
          :rules="rules"
          ref="searchForm"
        >
          <el-form-item label="包件编码">
            <el-input v-model="searchForm.packCode" @keyup.enter.native="onSearch"/>
          </el-form-item>
          <el-form-item label="包件名称">
            <el-input v-model="searchForm.packName" @keyup.enter.native="onSearch"/>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch"
            >搜索</el-button
          >
          <el-button class="orange-btn" size="mini" @click="reset"
            >重置</el-button
          >
        </template>
      </search-box>
    </template>


    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="dispose">新增</el-button>
        <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="packCode" label="包件编码" align="center"></el-table-column>
        <el-table-column prop="packName" label="包件名称" align="center"></el-table-column>
        <el-table-column prop="importTime" label="导入时间" align="center"></el-table-column>
        <el-table-column prop="importPerson" label="导入人" align="center"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" style="color: red" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <add-dialog
      :visible.sync="isShowDispose"
      v-if="isShowDispose"
      @success="onSearch"
    />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import addDialog from "./add.vue";
import moment from "moment";
export default {
  name: "packageRemovalInformation",
  mixins: [tableMixin, pagePathMixin],
  components: { addDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "withDrawPackInfoReport",
      columnData: [],
      loading: false,
      searchForm: {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      },
      exportData: {},
      searchCollapse: false,
      isShowDispose: false,
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: { },
  methods: {
    onSearch() {
      let platCodeType = this.searchForm.packCode && this.searchForm.packCode.split(" ").length > 1000
      if(platCodeType) {
        this.$message.error('已超过1000条，请核对！')
        return
      }
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "packCode", //包件编码
          val: this.searchForm.packCode ? this.searchForm.packCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "packName", //包件名称
          val: this.searchForm.packName ? this.searchForm.packName : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter(
        (item) => item.val.length && item.val[0]
      );
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      this.searchForm = {
        platName: "",
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    dispose() {
      this.isShowDispose = true;
    },

    async del(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", {
        type: "warning",
      });
      if (status !== "confirm") return;
      const params = {
        fragment: [row.dataId]
      };
      let res = await this.$q.product.withdrawDel(params);
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail(res.message);
      }
      this.onSearch();
    },

    //导入
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/product/packageRemovalInformationImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "包件下架信息维护导入.xlsx",
          appCode: "ec-pc-new",
          reportName: 'withDrawPackInfoImport'
        },
      });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
        } else {
          this.$message.error(res.message)
        }
      }).finally(_=>{
        loading.close()
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch()
  },
};
</script>

<style lang="stylus" scoped>
// >>> .el-form-item {
//   margin-bottom: 10px;
// }

</style>
